<template>
  <div>
    <div class="card card-custom gutter-b">
      <div class="card-body">
        <div class="d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap">
          <div class="d-flex align-items-center flex-wrap mr-1">
            <h5 class="text-dark font-weight-bold my-1 mr-5">
              <title-head v-bind:api_data="api_data"></title-head>
            </h5>
          </div>
          <div class="d-flex align-items-center">
            <ul class="nav nav-pills nav-pills-sm nav-dark-75">
              <li class="nav-item">
                <div
                    v-on:click="activateTabs('operationBasicInformation')"
                    :class="'nav-link py-2 px-4 '  + basic_information_class" data-toggle="tab">
                  Basic
                </div>
              </li>
              <li class="nav-item">
                <div
                    v-on:click="activateTabs('operationLandInformation')"
                    :class="'nav-link py-2 px-4 '  + land_information_class" data-toggle="tab">
                  Land
                </div>
              </li>
              <li class="nav-item">
                <div
                    v-on:click="activateTabs('operationLivelihoodInformation')"
                    :class="'nav-link py-2 px-4 '  + livelihood_information_class" data-toggle="tab">
                  Livelihood
                </div>
              </li>
              <li class="nav-item">
                <div
                    v-on:click="activateTabs('operationCultivationInformation')"
                    :class="'nav-link py-2 px-4 '  + cultivation_information_class" data-toggle="tab">
                  {{ $t('Cultivation') }}
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="tab-content">
      <div :class="'tab-pane fade show ' + basic_information_class" id="basic_information" role="tabpanel"
           aria-labelledby="basic_information">
        <div v-if="api_data.action == 'show'">
          <div class="row">
            <div class="col-md-4">
              <show-basic-information v-bind:api_data="api_data"></show-basic-information>
            </div>
            <div class="col-md-4">
              <show-family-information v-bind:api_data="api_data"></show-family-information>
            </div>
            <div class="col-md-4">
              <show-gov-scheme-information v-bind:api_data="api_data"></show-gov-scheme-information>
            </div>
          </div>
        </div>
        <div v-if="api_data.action == 'edit' || api_data.action == 'add'">
          <div id="operationBasicInformation">
            <operation-basic-information v-bind:api_data="api_data"></operation-basic-information>
          </div>
          <div id="operationFamilyInformation">
            <operation-family-information v-bind:api_data="api_data"></operation-family-information>
          </div>
          <div id="operationGovSchemeInformation">
            <operation-gov-scheme-information
                v-bind:api_data="api_data"></operation-gov-scheme-information>
          </div>
        </div>
      </div>
      <div :class="'tab-pane fade show ' + land_information_class" id="land_information" role="tabpanel"
           aria-labelledby="land_information">
        <div v-if="api_data.action == 'show'" class="row">
          <div class="col-md-12">
            <show-land-information v-bind:api_data="api_data"></show-land-information>
          </div>
        </div>
        <div v-if="api_data.action == 'edit' || api_data.action == 'add'">
          <div id="operationLandInformation">
            <operation-land-information v-bind:api_data="api_data"></operation-land-information>
          </div>
        </div>
      </div>
      <div :class="'tab-pane fade show ' + livelihood_information_class" id="livelihood_information"
           role="tabpanel"
           aria-labelledby="livelihood_information">
        <div v-if="api_data.action == 'show'" class="row">
          <div class="col-md-12">
            <show-livelihood-information v-bind:api_data="api_data"></show-livelihood-information>
          </div>
        </div>
        <div v-if="api_data.action == 'edit' || api_data.action == 'add'">
          <div id="operationLivelihoodInformation">
            <operation-livelihood-information
                v-bind:api_data="api_data"></operation-livelihood-information>
          </div>
        </div>
      </div>
      <div :class="'tab-pane fade show ' + cultivation_information_class" id="cultivation_information"
           role="tabpanel"
           aria-labelledby="cultivation_information">
        <div v-if="api_data.action == 'show'" class="row">
          <div class="col-md-12">
            <show-cultivation-information v-bind:api_data="api_data"></show-cultivation-information>
          </div>
        </div>
        <div v-if="api_data.action == 'edit' || api_data.action == 'add'">
          <div id="operationCultivationInformation">
            <operation-cultivation-information
                v-bind:api_data="api_data"></operation-cultivation-information>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import showBasicInformation from './partials/showBasicInformation';
import showFamilyInformation from './partials/showFamilyInformation';
import showGovSchemeInformation from './partials/showGovSchemeInformation';
import showLandInformation from './partials/showLandInformation';
import showLivelihoodInformation from './partials/showLivelihoodInformation';
import showCultivationInformation from './partials/showCultivationInformation';
import operationBasicInformation from './partials/operationBasicInformation';
import operationFamilyInformation from './partials/operationFamilyInformation';
import operationGovSchemeInformation from './partials/operationGovSchemeInformation';
import operationLandInformation from './partials/operationLandInformation';
import operationCultivationInformation from './partials/operationCultivationInformation';
import operationLivelihoodInformation from "./partials/operationLivelihoodInformation";
import titleHead from "./titleHead";
import {FARMER_SINGLE} from "@/core/services/store/farmer.module";
import {mapGetters} from "vuex";
import ApiService from "@/core/services/api.service";

export default {
  components: {
    showBasicInformation,
    showFamilyInformation,
    showGovSchemeInformation,
    showLandInformation,
    showLivelihoodInformation,
    operationBasicInformation,
    showCultivationInformation,
    operationFamilyInformation,
    operationGovSchemeInformation,
    operationLandInformation,
    operationCultivationInformation,
    operationLivelihoodInformation,
    titleHead
  },
  mounted() {
    this.$nextTick(function () {
      if (localStorage.getItem('last_farmer_page_scroll_id')) {
        this.pageScrollID = localStorage.getItem('last_farmer_page_scroll_id');
      }
      this.activateTabs();
    });
  },
  async beforeRouteEnter(to, from, next) {
    let resultData = {};
    ApiService.setHeader();
    await ApiService.query(`farmer/${to.params.id}`)
        .then(({data}) => {
          resultData = data.response.data;
          next(vm => {
            vm.setFarmerData({
              Farmer: resultData,
              id: resultData.id,
            })
          });
        });
  },
  props: {
    api_data_start: {
      type: Object,
      required: true,
      default: function () {
        return {}
      },
    }
  },
  methods: {
    async getSingle(id) {
      await this.$store.dispatch(FARMER_SINGLE, {id: id});
      return this.getSingleFarmer;
    },
    setFarmerData(data) {
      this.api_data_start.Farmer = data.Farmer;
      this.api_data_start.id = data.id;
      this.api_data_start.action = 'edit';
      console.table(this.api_data_start);
    },
    activateTabs(pageScrollID = null) {
      if (pageScrollID) {
        this.pageScrollID = pageScrollID;
        localStorage.setItem('last_farmer_page_scroll_id', this.pageScrollID);
      }
      if (!this.pageScrollID) {
        this.pageScrollID = 'operationBasicInformation';
      }
      if (this.pageScrollID) {
        if (this.pageScrollID === 'operationBasicInformation') {
          this.basic_information_class = 'active';
          this.land_information_class = '';
          this.livelihood_information_class = '';
          this.cultivation_information_class = '';
        }
        if (this.pageScrollID === 'operationLandInformation') {
          this.land_information_class = 'active';
          this.livelihood_information_class = '';
          this.cultivation_information_class = '';
          this.basic_information_class = '';
        }
        if (this.pageScrollID === 'operationLivelihoodInformation') {
          this.livelihood_information_class = 'active';
          this.cultivation_information_class = '';
          this.land_information_class = '';
          this.basic_information_class = '';
        }
        if (this.pageScrollID === 'operationCultivationInformation') {
          this.cultivation_information_class = 'active';
          this.livelihood_information_class = '';
          this.land_information_class = '';
          this.basic_information_class = '';
        }
      }
    }
  },
  data: () => ({
    basic_information_class: '',
    land_information_class: '',
    livelihood_information_class: '',
    cultivation_information_class: '',
    pageScrollID: '',
    api_data: Vue.util.extend({}, this.api_data_start)
  }),
  computed: {
    ...mapGetters([
      "getSingleFarmer"
    ])
  }
}
</script>
